import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { ProductTabs } from "@modules/defaultProducts/components/ProductTabs";
import { useProductCreateForm } from "@pages/products/create/controller";

export const ProductCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useProductCreateForm();


  const handleSubmitValues = (data: any) => {
    const metadata: { [key: string]: any } = {}
    data.metadata = Object.values(data.metadata).map((meta: any) => 
      metadata[meta.key] = meta
    )
    data.metadata = metadata
    mutateAsync(data)
  }
  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(handleSubmitValues as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <ProductTabs />
      </FormProvider>
    </Create>
  );
});


